import * as types from '../constants/ActionTypes'

const INIT_STATE = {
  isWebappUser: false
};

const identity = (state = INIT_STATE, action) => {
  switch (action.type) {
    case types.GET_IDENTITY_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case types.USER_UPDATED: {
      const { id, firstName, lastName, mentionName } = action.payload;

      if (state.id === id) {
        return { ...state, firstName, lastName, mentionName };
      }

      return state;
    }
    case types.IDENTITY_IS_WEBAPP_USER:
      return {
        ...state,
        isWebappUser: action.payload
      };
    default:
      return state;
  }
};

export default identity;
